import React, { FC } from 'react';
import { Result } from 'antd';
import { Button } from '../../../../../components/Element';
import { SetupMarker } from '../../logic/accountSetupStorage';
import { useAuthLogic } from '../../logic/useAuth.logic';

// Shown in place of every page while the loaded user has an unresolved setup.
export const AccountSetupUnresolved: FC<{ marker: SetupMarker }> = ({ marker }) => {
  const { doSignOut } = useAuthLogic();
  return (
    <Result
      status="warning"
      title={`We couldn't confirm your account setup. Contact support and quote ${marker.username} and ${marker.submittedAt}.`}
      extra={<Button onClick={() => doSignOut()}>Sign out</Button>}
    />
  );
};

// Shown when the account or its role could not be loaded. The session is kept.
export const AccountLoadRetry: FC<{ onRetry: () => void }> = ({ onRetry }) => (
  <Result
    status="error"
    title="We couldn't load your account."
    subTitle="Check your connection and try again."
    extra={<Button onClick={onRetry}>Try again</Button>}
  />
);
